import Model from '../Model/Model';
import Menu from '../Menu/Menu';
import * as Map from '../Map/Map';
import Table from '../Table/Table';
import StackedBar from '../StackedBar/StackedBar';
import Tooltip from '../Tooltip/Tooltip';

var api = {
  go: function() {
    Model.load();
    Menu.init();
    Map.init();
    Table.init();
    StackedBar.init();
    Tooltip.init();
  },

  update: function() {
    // Map.update();
  }
};

export default api;



/** WEBPACK FOOTER **
 ** ./src/App/App.js
 **/